import Skeleton from 'react-loading-skeleton'
import { PropsWithClassName } from 'types'

interface Props extends PropsWithClassName {
  imageAspectRatio?: 'responsive' | '4/3'
}

export function ArticleCardSkeleton({ className, imageAspectRatio }: Props) {
  return (
    <div className={className}>
      <div className='flex flex-col items-start'>
        <div
          className='relative h-full w-full'
          style={{ paddingBottom: imageAspectRatio === '4/3' ? '75%' : '100%' }}
        >
          <Skeleton
            className='h-full w-full'
            containerClassName='absolute left-0 top-0 w-full h-full'
          />
        </div>

        <Skeleton
          containerClassName='w-1/4 block mt-2'
          className='min-h-[1.5rem] w-full'
        />

        <div className='mt-3.5 flex h-full w-full flex-col'>
          <Skeleton containerClassName='h-5 w-full' className='h-full w-full' />

          <div className='mt-2 flex flex-col space-y-2.5'>
            <Skeleton containerClassName='h-2 block' />
            <Skeleton containerClassName='h-2 block' />
          </div>
        </div>
      </div>
    </div>
  )
}
